export function initializeCompany() {
    return {
        type: 'COMPANY_INITIALIZE',
    }
}

export function getCurrentCompany() {
    return {
        type: 'API_GET_CURRENT_COMPANY',
        payload: {
            request: {
                method: 'GET',
                url: '/company'
            }
        }
    }
}

export function getCompany(id) {
    return {
        type: 'API_GET_COMPANY',
        payload: {
            request: {
                method: 'GET',
                url: `/companies/${id}`
            },
        }
    }
}

export function getCompanies() {
    return {
        type: 'API_GET_COMPANIES',
        payload: {
            request: {
                method: 'GET',
                url: `/companies`
            },
        }
    }
}

export function putCurrentCompany(company) {
    return {
        type: 'API_PUT_COMPANY',
        payload: {
            request: {
                method: 'PUT',
                url: `/companies/${company.id}`,
                data: company,
            },
        }
    }
}

export function postCompany(company) {
    return {
        type: 'API_POST_COMPANY',
        payload: {
            request: {
                method: 'POST',
                url: `/companies`,
                data: company,
            },
        }
    }
}

export function putCompany(company) {
    return {
        type: 'API_PUT_COMPANY',
        payload: {
            request: {
                method: 'PUT',
                url: `/companies/${company.id}`,
                data: company,
            },
        }
    }
}

export function getCompanyDates(id) {
    return {
        type: 'API_GET_COMPANY_DATES',
        payload: {
            request: {
                method: 'GET',
                url: `/companies/${id}/date`
            },
        }
    }
}

export function companyInit() {
    return {
        type: 'API_COMPANY_INIT'
    }
}

export function closeGetCompanyFetch() {
    return {
        type: 'API_GET_COMPANY_CLOSE_FETCH'
    }
}

export function closeGetCompaniesFetch() {
    return {
        type: 'API_GET_COMPANIES_CLOSE_FETCH'
    }
}

export function closePostCompanyFetch() {
    return {
        type: 'API_POST_COMPANY_CLOSE_FETCH'
    }
}

export function closePutCompanyFetch() {
    return {
        type: 'API_PUT_COMPANY_CLOSE_FETCH'
    }
}

export function closeGetCompanyDateFetch() {
    return {
        type: 'API_GET_COMPANY_DATE_CLOSE_FETCH'
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/companies.js